import React from "react";
import _ from "lodash";

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

import {PrimaryButton} from "../../../components/Buttons";
import CreateLinkPopup from "../AssetForm/components/CreateLinkPopup";
import {ASSETS_LIABILITIES_CONFIG} from "../constants";
import LinkedItemsList from "./components/LinkedItemsList";

import styles from "./styles";

const LinksHeader = withStyles(styles)(({classes, itemsForLinks, currentLinkedItems, objectType, setLinkedItems}) => {
  const [showCreateLinkPopup, setShowCreateLinkPopup] = React.useState(false);

  const itemsAvailableForLinks = React.useMemo(() => {
    const availableToSelect = {};
    itemsForLinks.forEach(category => {
      category.assets.forEach(asset => {
        const selected = !!currentLinkedItems.find(i => i.type_id == asset.type_id && i.id === asset.id);

        // expired assets should be listed only if already selected
        if(!asset.is_expired || selected) {

          if (!availableToSelect.hasOwnProperty(category.id)) {
            availableToSelect[category.id] = {...category, assets: []};
          }

          availableToSelect[category.id].assets.push({...asset, selected});
        }
      })
    });

    return _.orderBy(Object.values(availableToSelect), 'total_value', 'desc');
  }, [itemsForLinks, currentLinkedItems]);

  const handleSaveClick = (items) => {
    setLinkedItems([...items]);
    setShowCreateLinkPopup(false);
  };

  const assetTypeConfig = ASSETS_LIABILITIES_CONFIG[objectType];
  const noItemsToLink = _.isEmpty(itemsAvailableForLinks);

  return (
    <Grid container alignItems={"center"}>
      <Grid item xs className={classes.addHeadline}><b>Verknüpfungen</b></Grid>
      <Grid item xs={'auto'}>
        <PrimaryButton
          variant={'outlined'}
          text={assetTypeConfig.linkItemLabel}
          icon={<i className={'fal fa-plus'} />}
          onButtonClick={() => setShowCreateLinkPopup(true)}
          disabled={noItemsToLink}
          tooltip={noItemsToLink ? assetTypeConfig.noItemsToLinkMsg : undefined}
        />
        {showCreateLinkPopup && (
          <CreateLinkPopup
            objectType={objectType}
            handleClose={() => setShowCreateLinkPopup(false)}
            itemsForLinks={itemsAvailableForLinks}
            handleSaveClick={handleSaveClick}
          />
        )}
      </Grid>
    </Grid>
  )
});

const LinkedItemsSection = ({objectType, itemsForLinks, currentLinkedItems=[], setLinkedItems, mainItemTypeId}) => {
  const deleteLink = (itemToDelete) => {
    setLinkedItems(currentLinkedItems.filter(
      item => !(itemToDelete.type_id === item.type_id && item.id === itemToDelete.id)
    ))
  };

  return (
    <>
      <Grid item xs={12}>
        <LinksHeader
          itemsForLinks={itemsForLinks}
          objectType={objectType}
          currentLinkedItems={currentLinkedItems}
          setLinkedItems={setLinkedItems}
        />
      </Grid>
      {currentLinkedItems.length > 0 && (
        <Grid item xs={12}>
          <LinkedItemsList
            linkedItems={currentLinkedItems}
            objectType={objectType}
            deleteLink={deleteLink}
            mainItemTypeId={mainItemTypeId}
          />
        </Grid>
      )}
    </>
  )
};

export default LinkedItemsSection;